import { I18NextContext } from '../@types/types'

export const getLanguagePath = (
  language: string,
  languageContext: I18NextContext
) => {
  return languageContext.generateDefaultLanguagePage ||
    language !== languageContext.defaultLanguage
    ? `/${formatLang(language)}`
    : ''
}

export const formatLang = (language: string) => {
  switch (language.toLowerCase()) {
    case 'en-gb':
    case 'uk':
      return 'uk'
    case 'en-ca':
    case 'ca':
      return 'ca'
    case 'en-ie':
    case 'ie':
      return 'ie'
    case 'en-us':
    case 'us':
    default:
      return ''
  }
}

// This is coming from Gatsby's internals: https://github.com/gatsbyjs/gatsby/blob/2975c4d1271e3da52b531ad2f49261c362e5ae13/packages/gatsby-link/src/index.js#L42-L46
export const isExternalLink = (path: string) =>
  path?.startsWith(`http://`) ||
  path?.startsWith(`https://`) ||
  path?.startsWith(`//`)

export const localizeLink = (
  href: string,
  language?: string,
  languageContext?: I18NextContext
) => {
  const urlLanguage = language || languageContext.language

  // Don't localize if this is a page anchor link or an external link... and skip the whole thing if href doesn't exist
  if (
    !href ||
    href?.startsWith('#') ||
    isExternalLink(href) ||
    ['en', 'us', 'en-us'].includes(urlLanguage.toLowerCase())
  ) {
    return href
  }

  // Don't localize if the URL already includes the locale
  const locales = ['ca', 'ie', 'uk']
  let skipLocalization = false
  locales.forEach((lang) => {
    if (href.startsWith(`${lang}/`) || href.startsWith(`/${lang}/`)) {
      skipLocalization = true
    }
  })

  // Can't return the value within the loop, so we need this extra if check here
  if (skipLocalization) {
    return href
  }

  return `${getLanguagePath(urlLanguage, languageContext)}${href}`
}

// Smooth scrolls to the target element
export const anchorLinkScroll = (target: string) => {
  if (typeof window !== 'undefined') {
    const sectionTop =
      document.querySelector(target).getBoundingClientRect().top +
      window.scrollY -
      140

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    })
  }
}
